var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{class:{ undressed: _vm.undressed },attrs:{"href":_vm.href,"target":"_system"},on:{"click":function($event){return _vm.clicked($event)}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }